import PL_utils from './vendor/pl-utils.js';
import modal from './vendor/modal.js';

// eslint-disable

const body = document.querySelector('body');
const isEDMode = window.location.href.indexOf('ed=1') >= 0;

//MODAL EXIT
const exitModalEle = document.getElementById('exit-modal');


export default () => {
    if(!exitModalEle){
        return;
    }
    const exitContinueBtn = exitModalEle.querySelector('.modal__continue');
    const exitModalTriggers = document.querySelectorAll('[data-external]');

    PL_utils.eleOnClick(function (e) {
        e.preventDefault();
        const link = e.currentTarget.getAttribute('href');
        modal.open(e.currentTarget);
        exitContinueBtn.setAttribute('href', link);
        PL_utils.addClass('modal-open', body);
        PL_utils.addClass('modal-open--exit', body);
    }, exitModalTriggers);

    // Close modal if they exit
    PL_utils.eleOnClick(() => {
        modal.close();
    }, exitContinueBtn);

    document.addEventListener('modalBeforeClose', () => {
        PL_utils.removeClass('modal-open', body);
        PL_utils.removeClass('modal-open--exit', body);
    });

    //screenshot
    if (isEDMode && window.location.href.indexOf('modal=external') > 0) {
        const exitModalButton = document.querySelector('[data-external]');
        modal.open(exitModalButton);
        document.getElementById('exit-modal').classList.add('ss-focus');
        window.scrollTo(0, 0);
    }
    
};
